var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 8,
    viewBox: "0 0 25 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.854 4.354a.5.5 0 000-.708L21.672.464a.5.5 0 10-.707.708L23.793 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM.5 4.5h24v-1H.5v1z",
    fill: "#5B5675"
  })));
}
export default SvgRightArrow;